export default {
  customDashboard: {
    loading: 'Caricamento...',
    loadingData: 'Caricamento dati...',
    selectedSensors: '{count} sensori selezionati',
    addNewChart: 'Aggiungi nuovo grafico',
    chartTitle: 'Titolo grafico',
    selectSensors: 'Seleziona sensori',
    selectSensorValidation: 'Seleziona almeno un sensore',
    chartType: 'Tipo di grafico',
    selectChartType: 'Seleziona un tipo di grafico',
    startDate: 'Data inizio',
    endDate: 'Data fine',
    invalidDateRange: 'Intervallo date non valido',
    sensorColors: 'Colori sensori',
    others: 'altri',
    buttons: {
      cancel: 'Annulla',
      confirm: 'Conferma',
      update: 'Aggiorna'
    },
    editChart: 'Modifica grafico',
    buttonColors: {
      green: '{sensorName} - Verde',
      yellow: '{sensorName} - Giallo',
      red: '{sensorName} - Rosso'
    },
    selectDateRange: 'Seleziona intervallo date',
    quickFilters: 'Filtri Rapidi',
    weeklyConsumption: 'Consumo Settimanale',
    dataManager: 'Gestione Dati',
    lastRefilling: 'Ultima ricarica',
    dispenserLevel: 'Livello Dispenser',
    time: 'Orario',
    levelStatus: 'Livello di riempimento',
    fullEmptyDispenser: 'Dispenser Pieno/Vuoto',
    emptyHours: 'Ore Vuoto',
    consumptions: 'Consumi',
    downloadChartData: 'Scarica Dati Grafico',
    downloadAllData: 'Scarica Tutti i Dati',
    addNewWidget: 'Aggiungi nuovo widget',
    widgetType: 'Tipo di widget',
    chartTemplate: 'Template grafico',
    comparisonLevel: 'Livello di confronto',
    entitiesToCompare: 'Entità da confrontare',
    period: 'Periodo',
    widgetTitle: 'Titolo widget',
    size: 'Dimensione',
    filters: {
      title: 'Filtri',
      clients: 'Clienti',
      buildings: 'Edifici',
      floors: 'Piani',
      areas: 'Aree',
      dispenserType: 'Tipologia Dispenser',
      productType: 'Tipologia Prodotto',
      selectAll: 'Seleziona tutto',
      deselectAll: 'Deseleziona tutto'
    },
    sizes: {
      small: 'Piccolo',
      medium: 'Medio',
      large: 'Grande'
    },
    kpiType: 'Tipo KPI',
    dataLevel: 'Livello dati',
    articleType: 'Tipo articolo',
    edit: 'Modifica',
    delete: 'Elimina',
    kpiTypes: {
      totalConsumption: {
        title: 'Consumo Totale Carta',
        description: 'Totale della carta consumata nel periodo selezionato'
      },
      averageDaily: {
        title: 'Consumo Medio Giornaliero',
        description: 'Media giornaliera del consumo di carta'
      },
      mostUsedArticle: {
        title: 'Articolo Più Utilizzato',
        description: 'Tipo di carta più utilizzata, in percentuale sul totale'
      },
      inactiveZones: {
        title: 'Zone Inattive',
        description: 'Numero di zone senza attività rilevata'
      },
      estimatedCost: {
        title: 'Costo Stimato Carta',
        description: 'Costo stimato della carta consumata'
      },
      peakUsageDay: {
        title: 'Giorno Picco Utilizzo',
        description: 'Giorno con la frequenza d\'uso più alta nel periodo'
      }
    },
    chartTypes: {
      paperConsumption: {
        title: 'Consumo Carta',
        description: 'Confronto sul consumo totale di carta'
      },
      usageFrequency: {
        title: 'Frequenza Utilizzo',
        description: 'Confronto sulla frequenza d\'uso delle aree o dei dispenser'
      },
      paperCost: {
        title: 'Costo Carta',
        description: 'Confronto sul costo stimato legato all\'uso della carta'
      },
      alertEvents: {
        title: 'Eventi Alert',
        description: 'Confronto sul numero di eventi di alert registrati'
      },
      consumptionVsFrequency: {
        title: 'Consumo vs Frequenza',
        description: 'Confronto tra il consumo giornaliero e la frequenza di utilizzo di un\'area'
      },
      sensorComparison: {
        title: 'Confronto Sensori',
        description: 'Confronto tra serie storiche di sensori selezionati'
      },
      consumptionVsBathroom: {
        title: 'Consumo vs Utilizzo Bagno',
        description: 'Correlazione tra consumo carta e frequenza di utilizzo del bagno'
      }
    },
    sensorCategories: {
      dispenser: 'Dispenser',
      doors: 'Porte'
    },
    sensorComparison: {
      title: 'Confronto Sensori',
      selectSensors: 'Seleziona sensori da confrontare',
      selectCategory: 'Seleziona categoria',
      noSensorsSelected: 'Seleziona almeno un sensore per il confronto',
      loading: 'Caricamento dati sensori...'
    }
  },
  sensor: {
    error: {
      loading: 'Errore nel caricamento dei dettagli del sensore',
      updating: 'Errore nell\'aggiornamento del sensore',
      requiredFields: 'Compilare tutti i campi obbligatori',
      title: 'Errore',
      emptyFields: 'I seguenti campi sono obbligatori: {fields}',
      duplicateDevEui: 'Questo ID sensore esiste già nel sistema',
      duplicateDevEuiHint: 'Il Sensor ID inserito è già associato ad un altro sensore. Inserire un ID univoco.',
      creation: 'Errore nella creazione del sensore',
      creating: 'Errore durante la creazione del sensore',
      checkingExistence: 'Errore durante la verifica del sensore',
    },
    add: {
      title: 'CONFIGURAZIONE RAPIDA SENSORE: Compilare i campi sottostanti'
    },
    duplicate: {
      title: 'DUPLICA CONFIGURAZIONE SENSORE: Compilare i campi sottostanti'
    },
    fields: {
      sensorId: 'ID Sensore',
      dispenserName: 'Nome Dispenser',
      dispenserBrand: 'Marca Dispenser',
      dispenserArticleCode: 'Codice Articolo Dispenser',
      consumableBrand: 'Marca Consumabile',
      consumableArticleCode: 'Codice Articolo Consumabile',
      client: 'Cliente',
      building: 'Edificio',
      floor: 'Piano',
      area: 'Area',
      maxSheets: 'N. massimo fogli',
      maxValue: 'Valore Massimo - Distanza Dispenser vuoto (mm)',
      minValue: 'Valore Minimo - Distanza Dispenser pieno (mm)',
      buttonType: 'Tipologia Button'
    },
    selectDispenser: 'Seleziona Dispenser',
    notManagedYet: 'Non ancora gestito',
    emptyHours: 'Ore Vuoto',
    full: 'Pieno',
    empty: 'Vuoto'
  },
  login: {
    title: 'Accesso',
    button: 'Accedi',
    username: 'Nome utente',
    password: 'Password',
    error: 'Nome utente o password non corretti!',
    close: 'Chiudi',
    forgotPassword: 'Password dimenticata',
    resetPassword: 'Reimposta Password',
    resetPasswordInstructions: 'Inserisci l\'email utilizzata durante la registrazione',
    email: 'Email',
    resetRequested: 'Reset richiesto per:',
    enterNewPassword: 'Inserisci la nuova password nei campi sottostanti (assicurati che entrambe le password siano uguali per procedere)',
    newPassword: 'Nuova password',
    confirmPassword: 'Conferma nuova password',
    passwordsDontMatch: 'Le password non corrispondono'
  },
  KEY001: 'Accesso',
  key006: 'Nome utente o password non corretti!',
  key007: 'Chiudi',
  validation: {
    required: 'Questo campo è obbligatorio',
    duplicateDevEui: 'Questo ID sensore esiste già'
  },
  building: {
    add: {
      title: 'CREA NUOVO EDIFICIO: Compilare i campi sottostanti'
    },
    fields: {
      name: 'Nome edificio',
      address: 'Indirizzo edificio'
    },
    error: {
      creation: 'Errore nella creazione dell\'edificio'
    }
  },
  floor: {
    add: {
      title: 'CREA NUOVO PIANO: Compilare i campi sottostanti'
    },
    fields: {
      name: 'Nome piano',
      building: 'Edificio'
    },
    error: {
      creation: 'Errore nella creazione del piano'
    }
  },
  area: {
    add: {
      title: 'CREA NUOVA AREA: Compilare i campi sottostanti'
    },
    fields: {
      name: 'Nome area',
      building: 'Edificio',
      floor: 'Piano'
    },
    error: {
      creation: 'Errore nella creazione dell\'area'
    }
  },
  washroomFrequency: {
    selectSensor: 'Seleziona un sensore bagno per continuare',
    loading: 'Caricamento...',
    client: 'Cliente',
    building: 'Edificio',
    floor: 'Piano',
    area: 'Area',
    sensor: 'Sensore',
    back: 'INDIETRO',
    ok: 'OK',
    quickFilters: 'Filtri rapidi:',
    hours: '4 ORE',
    day: '1 GIORNO',
    week: '1 SETTIMANA',
    twoWeeks: '2 SETTIMANE',
    thirtyDays: '30 GIORNI',
    selectDateRange: 'Seleziona intervallo date',
    cancel: 'Annulla',
    trafficOverview: 'PANORAMICA TRAFFICO',
    currentTraffic: 'TRAFFICO ATTUALE',
    name: 'Nome:',
    sensorType: 'Tipo Sensore:',
    sensorTypes: {
      'People Counter': 'People Counter',
      'Occupancy (PIR)': 'Occupazione (PIR)',
      'Door Counter': 'Sensore Porta'
    },
    lastCleaning: 'Ultima Pulizia:',
    averageAlertsNo: 'N° Medio Alert:',
    averageDailyTraffic: 'Traffico Medio<br>(periodo selezionato):',
    averageDailyAlertsPeriod: 'Alert medi giornalieri<br>(periodo selezionato):',
    dailyTraffic: 'Traffico Giornaliero:',
    time: 'Ora:',
    cleaningStatus: 'Livello di pulizia',
    alertThreshold: 'Soglia allarme:',
    currentTrafficValue: 'Traffico Attuale',
    dataManager: 'GESTORE DATI',
    sensorName: 'Nome sensore:',
    cleaningSchedule: 'REGISTRO PULIZIE',
    washroomUsageFrequency: 'FREQUENZA UTILIZZO BAGNO',
    usageWithAlerts: 'UTILIZZO CON/SENZA ALERT NELLA PAGINA',
    events: 'Eventi',
    cleaningRequired: 'Pulizia Richiesta',
    mightNeedClean: 'Potrebbe necessitare pulizia',
    doesntNeedClean: 'Non necessita pulizia',
    usageByDaytime: 'UTILIZZO PER PERIODO GIORNALIERO',
    morning: 'Mattino (00:00 - 12:00)',
    afternoon: 'Pomeriggio (12:00 - 24:00)',
    usageByFourHourly: 'UTILIZZO PER FASCE ORARIE (4 ORE)',
    f1: 'F1 (00–04)',
    f2: 'F2 (04–08)',
    f3: 'F3 (08–12)',
    f4: 'F4 (12–16)',
    f5: 'F5 (16–20)',
    f6: 'F6 (20–24)',
    trafficVolumeVsAlert: 'VOLUME TRAFFICO VS STATO ALERT',
    normalTraffic: 'Traffico Normale',
    trafficDuringAlert: 'Traffico con Alert Attivo',
    eventToAlert: 'Mancanti all\'alert',
    eventTriggered: 'Traffico registrato',
    serviceEfficiencyTimeline: 'EFFICIENZA INTERVENTI PULIZIA',
    responseTime: 'Tempo di Risposta',
    cleaned: 'Pulito',
    alert: 'Allarme',
    sensorOverview: 'Panoramica sensore',
    online: 'Online',
    offline: 'Offline',
    lastDataReceivedLabel: 'Ultimo dato ricevuto',
    lastCleaningLabel: 'Ultima pulizia',
    alertThresholdLabel: 'Soglia alert',
    currentTrafficTitle: 'Traffico attuale',
    aboveThreshold: 'Sopra soglia',
    belowThreshold: 'Sotto soglia',
    live: 'Live',
    trafficLegend: 'Traffico',
    thresholdLegend: 'Soglia',
    remainingRange: 'Range residuo',
    thresholdLabel: 'Soglia',
    entriesUnit: 'entrate',
    avgDailyTrafficKpi: 'Traffico medio giornaliero',
    averageEntriesPerDay: 'Entrate medie al giorno',
    peakTrafficWindow: 'Fascia oraria di picco',
    avgDailyCleaningActivities: 'Attività medie di cleaning giornaliere',
    validatedOperationsPerDay: 'Operazioni validate al giorno',
    avgTrafficPerCleaning: 'Traffico medio per pulizia',
    entriesPerCleaning: 'Entrate gestite per pulizia',
    avgDailyAlertsKpi: 'Alert medi giornalieri',
    thresholdExceedancesPerDay: 'Superamenti soglia al giorno',
    avgActiveHoursPerDay: 'Ore attive medie / giorno',
    hoursWithRecordedTraffic: 'Ore con traffico registrato'
  },
  manageSensors: {
    title: 'Gestione Sensori',
    addNewSensor: 'Aggiungi nuovo sensore',
    sensorDeleting: 'Eliminazione Sensore',
    deleteConfirm: 'Sei sicuro di voler eliminare "{name}"?',
    client: 'Cliente',
    building: 'Edificio',
    floor: 'Piano',
    area: 'Area',
    sensor: 'Sensore',
    clearFilter: 'Rimuovi filtri',
    filter: 'Filtra',
    type: 'Tipo',
    fillLevel: 'Livello riempimento',
    liveUsage: 'Uso Attuale',
    cleaningLimit: 'Soglia pulizia',
    name: 'Nome',
    company: 'Azienda',
    battery: 'Batteria',
    sensorId: 'ID Sensore',
    actions: 'Azioni',
    tooltips: {
      edit: 'Modifica sensore',
      duplicate: 'Duplica sensore',
      delete: 'Elimina sensore'
    },
    buttonSubtypes: {
      feedback: 'Feedback',
      click: 'Servizio',
      RFID: 'RFID Validazione',
      display: 'Pannello',
      RFID_BUTTON: 'RFID Button'
    },
    dispenserSubtypes: {
      foldedHandTowels: 'Asciugamani piegati',
      handTowelRolls: 'Rotoli Asciugamani',
      foldedToiletPaper: 'Carta igienica piegata',
      toiletPaperRolls: 'Carta igienica rotoli',
      soap: 'Sapone'
    },
    editSensor: 'MODIFICA SENSORE',
    update: 'Aggiorna',
    noDataAvailable: 'Nessun dato disponibile'
  },
  alerts: {
    title: 'Avvisi',
    alertTime: 'ORA AVVISO',
    solvedTime: 'ORA RISOLUZIONE',
    message: 'MESSAGGIO',
    markAsDone: 'Segna come completato',
    triggerAt: 'Attivato il',
    resolvedAt: 'Risolto il',
    duration: 'Durata',
    confirmResolve: 'Conferma Evasione Alert',
    confirmResolveMessage: 'Sei sicuro di voler segnare questo alert come {status}?',
    resolved: 'risolto',
    unresolved: 'non risolto',
    sensorDetails: 'Dettagli Sensore',
    sensorName: 'Nome Sensore',
    building: 'Edificio',
    floor: 'Piano',
    area: 'Area',
    triggeredAt: 'Attivato il',
    receivedAt: 'Ricevuto il',
    status: 'Stato',
    currentStatus: 'Stato Attuale',
    confirm: 'Conferma',
    cancel: 'Annulla',
    action: 'Azione'
  },
  dashboard: {
    title: 'Cruscotto',
    overview: 'Riepilogo',
    statistics: 'Statistiche',
    editWidget: 'Modifica Widget',
    addWidget: 'Aggiungi Widget',
    widgetSize: 'Dimensione Widget',
    size: 'Dimensione',
    small: 'Piccolo',
    medium: 'Medio',
    large: 'Grande',
    sizes: {
      small: 'Piccolo',
      smallDesc: 'Larghezza 1/4 - Widget compatti',
      medium: 'Medio',
      mediumDesc: 'Larghezza 1/2 - Widget standard',
      large: 'Grande',
      largeDesc: 'Larghezza completa - Widget grandi'
    },
    addNewWidget: 'Aggiungi nuovo widget',
    kpiWidget: 'Widget KPI',
    configureKpiWidget: 'Configura Widget KPI',
    widgetTitle: 'Titolo Widget',
    dataLevel: 'Livello Dati',
    selectClient: 'Seleziona Cliente',
    selectClients: 'Seleziona Clienti',
    selectBuilding: 'Seleziona Edificio',
    selectBuildings: 'Seleziona Edifici',
    selectFloor: 'Seleziona Piano',
    selectFloors: 'Seleziona Piani',
    selectArea: 'Seleziona Area',
    selectAreas: 'Seleziona Aree',
    selectSensor: 'Seleziona Sensore',
    selectSensors: 'Seleziona Sensori',
    selectEntity: 'Seleziona Entità',
    selectPeriod: 'Seleziona Periodo',
    customPeriod: 'Periodo Personalizzato',
    selectDateRange: 'Seleziona Intervallo Date',
    startDate: 'Data Inizio',
    endDate: 'Data Fine',
    client: 'Cliente',
    building: 'Edificio',
    floor: 'Piano',
    area: 'Area',
    sensor: 'Sensore',
    entitiesToCompare: 'Entità da Confrontare',
    kpiTypes: {
      restroomDailyUsage: {
        title: 'Utilizzo medio giornaliero area',
        description: 'Numero medio di ingressi giornalieri per area monitorata nel periodo selezionato.'
      },
      usageFrequencyComparison: {
        title: 'Confronto frequenza di utilizzo',
        description: 'Confronta l\'andamento dell\'utilizzo tra le aree selezionate per identificare i periodi di massima attività.'
      },
      dispenserFillHeatmap: {
        title: 'Heatmap livello di riempimento dispenser',
        description: 'Mostra il livello medio di riempimento dei dispenser nelle diverse fasce orarie giornaliere per l\'area selezionata.',
        tableTitle: 'Heatmap livello di riempimento dispenser',
        tableSubtitle: 'Percentuale media del livello di riempimento nel periodo selezionato.',
        colLocation: 'Dispenser e posizione area'
      },
      dispenserConsumptionAnalysis: {
        title: 'Consumo per Modello Dispenser',
        description: 'Confronta il consumo dei materiali di consumo per dispenser, posizione e visite nel periodo selezionato.'
      }
    },
    dispenserConsumptionAnalysis: {
      tableTitle: 'Analisi dei consumabili per dispenser',
      tableSubtitle: 'Confronta il consumo dei materiali di consumo per dispenser, posizione e visite nel periodo selezionato.',
      unitRolls: 'UNITÀ: ROTOLI',
      unitLiters: 'UNITÀ: LITRI',
      unitSheets: 'UNITÀ: FOGLI',
      groupHandTowelRoll: 'Rotoli carta asciugamani',
      groupFoldedTowels: 'Asciugamani piegati',
      groupToiletPaperRolls: 'Carta igienica in rotoli',
      groupFoldedToiletPaper: 'Carta igienica piegata',
      groupSoap: 'Sapone',
      groupTotal: 'TOTALE GRUPPO',
      colDispenser: 'DISPENSER',
      colLocation: 'POSIZIONE',
      colTotalConsumption: 'CONSUMO TOTALE',
      colAvgPerDay: 'MEDIA / GIORNO',
      colConsPer100Visits: 'CONS. / 100 INGRESSI'
    },
    periodOptions: {
      lastDay: 'Ultimo Giorno',
      last7Days: 'Ultimi 7 giorni',
      last14Days: 'Ultimi 14 giorni',
      last30Days: 'Ultimi 30 giorni',
      customPeriod: 'Periodo Personalizzato'
    },
    validation: {
      startDateRequired: 'La data di inizio è obbligatoria',
      endDateRequired: 'La data di fine è obbligatoria',
      endDateAfterStart: 'La data di fine deve essere successiva alla data di inizio',
      futureDateNotAllowed: 'La data di fine non può essere nel futuro. Seleziona fino a ieri.',
      startDateTooOld: 'La data di inizio non può essere più di 30 giorni fa. Seleziona una data più recente.',
      endDateBeforeStart: 'La data di fine deve essere successiva alla data di inizio.',
      periodTooShort: 'Il periodo deve essere di almeno 1 giorno.',
      periodTooLong: 'Periodo selezionato ({days} giorni). Considera periodi più brevi per prestazioni ottimali.',
      validPeriod: 'Periodo valido selezionato ({days} giorni).'
    },
    periodInfo: {
      period: 'Periodo',
      upTo: 'Fino al',
      dataFrom: 'Dati da',
      lastDay: 'Dati da ieri ({date}) - Fino al {date}',
      last7Days: 'Dati degli ultimi 7 giorni - Fino al {date}',
      last14Days: 'Dati degli ultimi 14 giorni - Fino al {date}',
      last30Days: 'Dati degli ultimi 30 giorni - Fino al {date}',
      customRange: 'Periodo personalizzato: {start} al {end} - Fino al {end}',
      selectCustomRange: 'Seleziona intervallo date personalizzato - Fino al {date}'
    },
    tableHeaders: {
      article: 'Articolo',
      device: 'Dispositivo',
      location: 'Posizione',
      packsUsed: 'Confezioni Usate',
      refillsPerDay: 'Rifornimenti / Giorno',
      restroom: 'Bagno',
      restroomAndLocation: 'Bagno & Posizione',
      avgEntriesPerDay: 'Media Ingressi / Giorno',
      status: 'Stato',
      dailyPattern: 'Pattern Giornaliero (AM vs PM)',
      avgAlertsPerDay: 'Media Alert / Giorno',
      trendVsPrevious: '▲ vs periodo precedente',
      trendVsLastWeek: 'Trend vs Periodo Precedente',
      deltaVsPrevious: 'Δ vs prec.',
      client: 'Cliente',
      building: 'Edificio',
      floor: 'Piano',
      area: 'Area',
      dispenser: 'Dispenser',
      item: 'Elemento',
      value: 'Valore'
    },
    status: {
      low: 'Basso',
      empty: 'Vuoto',
      normal: 'Normale',
      active: 'Attivo'
    },
    summary: {
      clientsSelected: '{count} Clienti selezionati',
      buildingsSelected: '{count} Edifici - {floors} Piani - {sensors} Dispenser selezionati',
      floorsSelected: '{building} - {count} Piani selezionati',
      clients: '{count} Clienti',
      buildings: '{count} Edifici',
      floors: '{count} Piani',
      areas: '{count} Aree',
      sensors: '{count} Sensori',
      selected: 'selezionati'
    },
    selectAll: 'Seleziona Tutto',
    restroomUsageSensorLevelOnly: 'Questo KPI richiede la selezione a livello di sensori. Naviga attraverso Cliente > Edificio > Piano > Area per selezionare i sensori specifici.'
  },
  alertsManagement: {
    pageTitle: 'Gestione Avvisi',
    createRule: 'Crea nuova regola',
    addNewAlert: 'Aggiungi Nuovo Alert',
    fillFields: 'Compilare i campi sottostanti',
    title: 'Titolo',
    alertName: 'NOME ALERT',
    email: 'email (usa ; per separare le email)',
    emailLabel: 'Email (usa ; per separare più email)',
    customMessage: 'Inserisci qui il tuo messaggio personalizzato:',
    alertValue: 'Valore Alert (%) - n. eventi',
    saveRule: 'Salva regola',
    sensor: 'SENSORE',
    emailAddresses: 'INDIRIZZI EMAIL',
    recipients: 'DESTINATARI',
    active: 'ATTIVO',
    status: 'STATO',
    phoneNumbers: 'NUMERI TELEFONO',
    airField: 'Campo da Monitorare',
    comparisonOperator: 'Operatore di Confronto',
    airFields: {
      pressure: 'Pressione',
      co2: 'CO2',
      temperature: 'Temperatura',
      humidity: 'Umidità'
    },
    buttonField: 'Tipo di Pressione',
    buttonFields: {
      short: 'Breve',
      long: 'Lunga',
      double: 'Doppia'
    },
    operators: {
      greaterThan: 'Maggiore di (>)',
      lessThan: 'Minore di (<)'
    },
    deleteConfirm: {
      title: 'Conferma Eliminazione',
      message: 'Sei sicuro di voler eliminare la regola "{title}"?',
      description: 'Questa azione non può essere annullata.'
    }
  },
  users: {
    title: 'Utenti',
    manageUser: 'Gestisci Utente',
    username: 'NOME UTENTE',
    role: 'RUOLO',
    active: 'ATTIVO',
    changePassword: 'Cambia Password',
    changePasswordTitle: 'Compila i campi sottostanti per cambiare la password',
    oldPassword: 'Vecchia password',
    newPassword: 'Nuova password',
    confirmNewPassword: 'Conferma nuova password',
    passwordMinLength: 'La password deve contenere almeno 6 caratteri',
    passwordMismatch: 'Le password non corrispondono',
    passwordChangedSuccess: 'Password modificata con successo',
    passwordChangeError: 'Si è verificato un errore durante il salvataggio della nuova password. Riprova o contatta il supporto.'
  },
  buildings: {
    title: 'Edifici',
    name: 'Nome',
    address: 'Indirizzo',
    sensors: 'Sensori'
  },
  smartDispenser: {
    selectSensor: 'Seleziona un dispenser smart per continuare',
    loading: 'Caricamento...',
    quickFilters: 'Filtri rapidi:',
    hours: '4 ORE',
    day: '1 GIORNO',
    threeDays: '3 GIORNI',
    week: '1 SETTIMANA',
    twoWeeks: '2 SETTIMANE',
    lastMonth: 'ULTIMO MESE',
    selectDateRange: 'Seleziona intervallo date',
    dataManager: 'GESTORE DATI',
    sensorName: 'Nome sensore:',
    lastRefill: 'Ultima ricarica:',
    consumption: 'Consumo:',
    binLevel: 'LIVELLO CESTINO',
    dispenserLevel: 'LIVELLO DISPENSER',
    dispenserAvailability: 'DISPONIBILITÀ DISPENSER – % PIENO vs VUOTO',
    dispenserDowntime: 'DISPENSER VUOTO – ORE VUOTE / GIORNO',
    consumptions: 'CONSUMI',
    units: {
      sheets: 'fogli',
      milliliters: 'millilitri',
      rolls: 'rotoli'
    },
    downloadChartData: 'Scarica dati grafico',
    downloadAllData: 'Scarica tutti i dati del sensore',
    refillSchedule: 'REGISTRO DELLE RICARICHE',
    levelStatus: 'Livello di riempimento:',
    time: 'Ora:',
    status: {
      offline: 'Offline - Nessun dato ricevuto oggi',
      needsRefill: 'Vuoto - Ricarica necessaria',
      lowLevel: 'Livello basso - Potrebbe necessitare ricarica',
      full: 'OK - Dispenser pieno'
    },
    dispenserOverview: 'Panoramica dispenser',
    online: 'Online',
    offline: 'Offline',
    lastDataReceived: 'Ultimo dato ricevuto',
    refillThreshold: 'Soglia di rifornimento',
    currentLevel: 'Livello attuale',
    currentCapacity: 'Capacità attuale',
    belowRefillThreshold: 'Sotto la soglia di rifornimento',
    aboveRefillThreshold: 'Sopra la soglia di rifornimento',
    live: 'Live',
    availableLevel: 'Livello disponibile',
    threshold: 'Soglia',
    remainingCapacity: 'Capacità residua',
    dispenserType: 'Tipo dispenser',
    avgDailyConsumption: 'Consumo medio giornaliero',
    sheetsUsedPerDay: 'Fogli usati al giorno',
    rollsUsedPerDay: 'Rotoli usati al giorno',
    mlUsedPerDay: 'ml usati al giorno',
    avgDailyFillLevel: 'Livello medio giornaliero',
    averageDispenserLevel: 'Livello medio del dispenser',
    avgRefillInterval: 'Intervallo medio di rifornimento',
    daysBetweenRefills: 'Giorni tra un rifornimento e l\'altro',
    avgDailyEmptyHours: 'Inefficienza media giornaliera',
    downtimePerDay: 'Tempo senza disponibilità al giorno',
    avgDailyAvailability: 'Disponibilità media giornaliera',
    timeAboveEmptyLevel: 'Tempo sopra il livello di esaurimento',
    avgLevelAtRefill: 'Livello medio al rifornimento',
    levelWhenRefillHappens: 'Livello al momento del rifornimento',
    includeWeekends: 'Includi weekend',
    selectedPeriod: 'Periodo selezionato',
    clearFilter: 'Rimuovi filtri',
    notAvailable: 'N/D'
  },
  smartBin: {
    selectSensor: 'Seleziona uno smart bin per continuare',
    binLevel: 'LIVELLO CESTINO',
    binFillLevel: 'LIVELLO RIEMPIMENTO CESTINO – LIVELLO',
    averageFillingLevel: 'LIVELLO DI RIEMPIMENTO MEDIO',
    fillLevel: 'Livello di riempimento'
  },
  airQuality: {
    selectSensor: 'Seleziona un sensore di qualità dell\'aria per continuare',
    co2Level: 'LIVELLO CO2',
    temperature: 'TEMPERATURA',
    humidity: 'UMIDITÀ',
    averageCo2: 'LIVELLO MEDIO CO2'
  },
  sensorDetails: {
    sensorDetails: 'Dettagli Sensore',
    deviceInfo: 'Informazioni Dispositivo',
    location: 'Posizione',
    status: 'Stato',
    lastUpdate: 'Ultimo Aggiornamento'
  },
  cleaningLog: {
    title: 'Registro Pulizie',
    time: 'Orario pulizia',
    date: 'Data',
    location: 'Posizione',
    operator: 'Operatore',
    trigger: 'Trigger',
    responseTime: 'Risposta da alert',
    trafficHandled: 'Affluenza da ultima pulizia',
    searchOperator: 'Cerca operatore',
    searchOperatorPlaceholder: 'Nome o ID badge...',
    noDataAvailable: 'Nessun intervento di pulizia disponibile',
    alert: 'Alert',
    routine: 'Routine',
    download: 'Scarica',
    downloadTooltip: 'Scarica Excel',
    quickFilters: 'Filtri rapidi:',
    timeSinceLastCleaning: 'Tempo dall\'ultima pulizia',
    selectDateRange: 'Seleziona intervallo date',
    today: 'Oggi',
    last7Days: '7 giorni',
    last14Days: '14 giorni',
    last30Days: '30 giorni',
    allPeriod: 'Tutti',
    sensorOverview: 'Panoramica sensore',
    totalCleanings: 'Pulizie totali',
    lastCleaning: 'Ultima pulizia',
    avgTraffic: 'Traffico medio',
    periodSummary: 'Riepilogo periodo',
    alertTriggered: 'Alert attivati',
    routineTriggered: 'Routine',
    totalTraffic: 'Traffico totale',
    avgResponseTime: 'Risposta media alert'
  },
  common: {
    save: 'Salva',
    cancel: 'Annulla',
    ok: 'OK',
    confirm: 'Conferma',
    delete: 'Elimina',
    edit: 'Modifica',
    add: 'Aggiungi',
    close: 'Chiudi',
    back: 'Indietro',
    next: 'Avanti',
    continue: 'Continua',
    update: 'Aggiorna',
    search: 'Cerca',
    loading: 'Caricamento...',
    noDataAvailable: 'Nessun dato disponibile',
    noDevicesConnected: 'Nessun dispositivo collegato',
    yes: 'Sì',
    no: 'No',
    error: 'Errore',
    saveChanges: 'Salva Modifiche',
    itemsPerPage: 'Elementi per pagina',
    all: 'Tutti',
    of: 'di',
    days: {
      sunday: 'Domenica',
      monday: 'Lunedì',
      tuesday: 'Martedì',
      wednesday: 'Mercoledì',
      thursday: 'Giovedì',
      friday: 'Venerdì',
      saturday: 'Sabato'
    }
  },

  cleaningEfficiency: {
    title: 'Efficienza Cleaning Area',
    loading: 'Caricamento...',
    client: 'Cliente',
    building: 'Edificio',
    floor: 'Piano',
    area: 'Area',
    dateRange: 'Intervallo date',
    includeWeekends: 'Includi weekend',
    clearFilter: 'Cancella filtri',
    quickFilters: 'Filtri rapidi:',
    last4Hours: '4 Ore',
    lastDay: '1 Giorno',
    lastWeek: '1 Settimana',
    last2Weeks: '2 Settimane',
    last30Days: '30 Giorni',
    deviceOverview: 'Panoramica dispositivo',
    online: 'Online',
    offline: 'Offline',
    lastDataReceived: 'Ultimo dato ricevuto',
    lastCleaning: 'Ultima pulizia',
    managedSensors: 'Sensori gestiti',
    cleaningType: 'Tipo pulizia',
    currentAreaStatus: 'Stato attuale area',
    areaRecentlyCleaned: 'Area recentemente pulita',
    live: 'Live',
    entriesSinceLastCleaning: 'Entrate dall\'ultima pulizia',
    trafficSinceLastCleaning: 'Traffico dall\'ultima pulizia',
    remainingRange: 'Range residuo',
    threshold: 'Soglia',
    avgReactionTime: 'Tempo medio di reazione',
    avgDailyCleans: 'Pulizie medie giornaliere',
    avgDailyAlerts: 'Alert medi giornalieri',
    avgManagedTraffic: 'Traffico medio gestito',
    avgDailyAreaEntries: 'Entrate medie giornaliere area',
    avgTimeBetweenCleanings: 'Tempo medio tra pulizie',
    reactionTimeDesc: 'Tempo di risposta dall\'alert alla pulizia',
    cleaningsPerDay: 'Pulizie al giorno',
    alertsPerDay: 'Superamenti soglia al giorno',
    managedTrafficDesc: 'Entrate medie gestite per pulizia',
    managedEntries: 'Entrate gestite',
    areaSensors: 'Sensori area',
    associatedSensors: 'sensori associati',
    entriesSinceLastCleaningLabel: 'entrate dall\'ultima pulizia',
    type: 'Tipo',
    name: 'Nome',
    liveUsage: 'Utilizzo live',
    cleaningThreshold: 'Soglia pulizia',
    avgDailyEntries: 'Entrate medie giornaliere',
    avgDailyEntriesDesc: 'Entrate medie giornaliere generate da ogni sensore nell\'area gestita.',
    dailyEfficiencyChart: 'Efficienza & Traffico giornaliero',
    cumulativeTraffic: 'Traffico cumulativo',
    alert: 'Alert',
    rfidClean: 'Pulizia RFID',
    alertThreshold: 'Soglia alert',
    noDataAvailable: 'Nessun dato disponibile per il periodo selezionato.',
    selectAreaToLoad: 'Seleziona cliente, edificio, piano e area per caricare i dati.',
  },
} 